import { Routes, Route } from "react-router-dom";
import { DetailPage } from "./modules/Product/Product";
import {
  AdminAddProduct,
  AdminLayout,
  AdminLogin,
  AdminProducts,
  ProtectedAdmin,
} from "./modules/Admin/Admin";
import { MainLayout } from "./components/layout/MainLayout";
import { Home } from "./modules/Home/Home";
import { Vintage } from "./modules/Vintage/Vintage";

function App() {
  return (
    <Routes>
      {/* Публичная часть с Header/Footer */}
      <Route element={<MainLayout />}>
        <Route path="/vintage" element={<Vintage />} />
        <Route path="/" element={<Home />} />
        <Route path="/products/:id" element={<DetailPage />} />
      </Route>

      {/* Админка отдельно */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<ProtectedAdmin />}>
        <Route element={<AdminLayout />}>
          <Route index element={<AdminProducts />} />
          <Route path="products" element={<AdminProducts />} />
          <Route path="add" element={<AdminAddProduct />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
